"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var InputBase_1 = __importDefault(require("@mui/material/InputBase"));
var styles_1 = require("@mui/material/styles");
exports.default = (0, styles_1.styled)(InputBase_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        flex: 1,
        color: theme.palette.riverstone,
        fontSize: theme.typography.fontSize,
        fontWeight: theme.typography.fontWeightMedium,
        letterSpacing: '-0.023em',
        height: 24,
        maxWidth: 100,
        input: {
            padding: theme.spacing(0.5, 0),
            width: 30,
            transition: 'width 0.2s ease-in-out',
            ':focus, &:not(:placeholder-shown)': {
                width: 100,
            },
        },
    });
});
